import React, { Component } from 'react'
import PropTypes from 'prop-types'

import differenceInDays from 'date-fns/differenceInDays'
import parseISO from 'date-fns/parseISO'
import cn from 'comma-number'
import { COMING_SOON_IMAGE } from 'Defaults'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import { ListingV2 } from 'Pages'
import { REPLIERS_PHOTO_SOURCE } from 'Utils/photoUtils'
import SvgIcon from 'Components/SvgIcon'
import { appendImageTimestamp } from 'Utils/listingUtils'
import ArchiveCardDetail from '../ArchiveCardDetail'

import {
  _CardContainer,
  _ArchiveCard,
  _InnerContainerFlex,
  _PrintToggleBtn,
  _ListingImg,
  _VisibilityIconContainer,
} from './styles'

export const TEST_IDS = {
  PRINT_BTN: 'printBtn',
  HIDE_SHOW_ICON: 'hideShowIconContainer',
}

class ArchiveCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isHiddenOnPrint: false,
    }
    this.togglePrintVisibility = this.togglePrintVisibility.bind(this)
  }

  togglePrintVisibility(e) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ isHiddenOnPrint: !this.state.isHiddenOnPrint })
  }

  // terminated same day
  render() {
    const {
      imgSrc,
      address,
      askingPrice,
      closedPrice,
      beds,
      baths,
      parkings,
      sqft,
      endDate,
      status,
      suiteNumber,
      entryDate,
      showPastSaleOnClick,
      lastItem = false,
      firstItem = true,
      isPrint,
      url,
      sqftMax,
      sqftMin,
      streetAddress,
      photoVersion,
      hiddenFields,
      handleContactAgentClick,
      userIsOneOfAgentAdminSupport,
      listingPage,
      listing,
      userIsAuthentificated,
      userEmailVerified,
      showLoginModal,
    } = this.props
    const { isHiddenOnPrint } = this.state
    const statusText = status
      ? status.replace('Deal', '') && status.replace('Unavailable', 'TBD')
      : ''
    const listedPeriod =
      status === 'Sold' || status === 'Leased'
        ? differenceInDays(parseISO(endDate), parseISO(entryDate))
        : ''
    const listingAddress =
      streetAddress || (address && address.split(',')[0].trim())
    const price = (listing?.closed_price || listing?.asking_price)
    const pricePerSqft = sqft > 0 && price && `$${cn(Math.round(price / sqft))}`
    const width = 320
    const height = 240

    const getFirstPhotoUrl = () => {
      if(hiddenFields?.photos) return COMING_SOON_IMAGE
      if(listing?.source === REPLIERS_PHOTO_SOURCE) {
        return imgSrc
      }
      return appendImageTimestamp(imgSrc || COMING_SOON_IMAGE, photoVersion)
    }
    const photoSrc = getFirstPhotoUrl()
    return (
      <_ArchiveCard
        to={'/' + url}
        openNewTab
        hideOnPrint={isHiddenOnPrint}
        onClick={showPastSaleOnClick}
        lastItem={lastItem}
        disableLink={isPrint || !userIsAuthentificated}
        alt={'Listing history at' + address}
        mobileModalChildren={
          // eslint-disable-next-line react/no-unstable-nested-components
          ({ closeModalPage }) => (
            <ListingV2
              listingId={listing?.id}
              modalListingData={listing}
              closeModalPage={closeModalPage}
              isArchived
            />
          )
        }
        mobileModalKey={`listingModal-${listing?.id}`}
      >
        <_CardContainer firstItem={firstItem} listingPage={listingPage}>
          <_InnerContainerFlex listingPage={listingPage}>
            <_ListingImg
              to={'/' + url}
              disableLink={isPrint}
              alt={'Listing history at' + address}
              mobileModalChildren={
                // eslint-disable-next-line react/no-unstable-nested-components
                ({ closeModalPage }) => (
                  <ListingV2
                    listingId={listing?.id}
                    modalListingData={listing}
                    closeModalPage={closeModalPage}
                    isArchived
                  />
                )
              }
              mobileModalKey={`listingModal-${listing?.id}`}
              listingPage={listingPage}
            >
              <ImagePlaceholder
                src={photoSrc}
                defaultSrc={COMING_SOON_IMAGE}
                alt={'listing history at ' + address}
                noLazy={isPrint}
                width={width}
                height={height}
              />
            </_ListingImg>
            <ArchiveCardDetail
              suiteNumber={suiteNumber}
              listingAddress={listingAddress}
              statusText={statusText}
              askingPrice={askingPrice}
              closedPrice={closedPrice}
              listedPeriod={listedPeriod || 0}
              entryDate={entryDate}
              endDate={endDate}
              beds={beds}
              baths={baths}
              parkings={parkings}
              sqft={sqft}
              sqftMax={sqftMax}
              sqftMin={sqftMin}
              isPrint={isPrint}
              hiddenFields={hiddenFields}
              handleContactAgentClick={handleContactAgentClick}
              isUserAgentAdminSupport={userIsOneOfAgentAdminSupport}
              userIsOneOfAgentAdminSupport={userIsOneOfAgentAdminSupport}
              pricePerSqft={pricePerSqft}
              listingPage={listingPage}
              userIsAuthentificated={userIsAuthentificated}
              userEmailVerified={userEmailVerified}
              showLoginModal={showLoginModal}
            />

            {isPrint && (
              <_PrintToggleBtn
                onClick={this.togglePrintVisibility}
                data-test-id={TEST_IDS.PRINT_BTN}
              >
                <_VisibilityIconContainer
                  data-test-id={TEST_IDS.HIDE_SHOW_ICON}
                  show={isHiddenOnPrint}
                >
                  <SvgIcon
                    role="img"
                    aria-label="svg icon password visible"
                    name="#icon-password-visible"
                    width={16}
                    height={16}
                  />
                </_VisibilityIconContainer>
              </_PrintToggleBtn>
            )}
          </_InnerContainerFlex>
        </_CardContainer>
      </_ArchiveCard>
    )
  }
}

ArchiveCard.propTypes = {
  imgSrc: PropTypes.string,
  address: PropTypes.string,
  askingPrice: PropTypes.string,
  closedPrice: PropTypes.string,
  beds: PropTypes.string,
  baths: PropTypes.number,
  parkings: PropTypes.number,
  sqft: PropTypes.number,
  endDate: PropTypes.string,
  status: PropTypes.string,
  lastItem: PropTypes.bool,
  firstItem: PropTypes.bool,
  suiteNumber: PropTypes.string,
  entryDate: PropTypes.string,
  showPastSaleOnClick: PropTypes.func,
  handleContactAgentClick: PropTypes.func,
  isPrint: PropTypes.bool,
  userIsOneOfAgentAdminSupport: PropTypes.bool,
  url: PropTypes.string,
  sqftMax: PropTypes.number,
  sqftMin: PropTypes.number,
  photoVersion: PropTypes.number,
  streetAddress: PropTypes.string,
  hiddenFields: PropTypes.shape({
    photos: PropTypes.bool,
    prices: PropTypes.bool,
    listing_info: PropTypes.bool,
  }),
  listingPage: PropTypes.bool,
  listing: PropTypes.shape({
    id: PropTypes.number,
    closed_price: PropTypes.number,
    asking_price: PropTypes.number,
    photo_base_url: PropTypes.string,
    source: PropTypes.string,
    mls_number: PropTypes.string,
    photo_version: PropTypes.number,
  }),
  userEmailVerified: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
  showLoginModal: PropTypes.func,
}

export default ArchiveCard
